export class Contest {
  id: number;
  name: string = null;
  startDate: any = null;
  endDate: any = null;
}
